// /skills — real route (design doc's G2). Thin-server-shell parity: the
// original (app/skills/page.tsx:11-19) is just
// `getEffectiveUserId() -> redirect('/sign-in?...') -> <SkillsClient/>`;
// the redirect-if-signed-out half is now the `_authed` guard
// (routes/guards.tsx) and SkillsClient already sets its own document title
// (app/skills/client.tsx:239), so this file is a pure mount. Registered
// into the route tree from routes/agents.tsx.
import { createRoute } from '@tanstack/react-router';
import { SkillsClient } from '@/app/skills/client';
import { authedRoute } from './guards';

export const skillsRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/skills',
  component: SkillsClient,
});
